<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <!--

<error-401 *ngIf="is401"></error-401>
        <error-404 *ngIf="is404"></error-404>

        <module-content>
            content !!!!
        </module-content>
        <full-width-loader *ngIf="isLoading"></full-width-loader>-->

    <ul id="main-menu">
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/diary/{{ defaultDay }}">{{ 'Calendar' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/feedback">{{ 'Feedback' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/plan">{{ 'AnnualPlan' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/documents">{{ 'Documents' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/evaluations">{{ 'Evaluations' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/tests">{{ 'Tests' | translate}}</a>
        </li>
        <li class="d-flex align-items-center">
            <a routerLink="/{{ this.dashboardUrl }}/users/{{ this.athleteUser.id }}/edit">{{ 'My_account' | translate}}</a>
        </li>
    </ul>
</mobile-page-content>
